import React from 'react';
import Layout from '../Components/Layout/Layout';
import NotificationList from '../Components/Notifications/NotificationList';

function NotificationsPage() {
  return (
    <Layout>
      <NotificationList />
    </Layout>
  );
}

export default NotificationsPage;
